import { createOrbindClient, type TokenStorage } from '@orbind/api-client'

const TOKEN_KEY = 'orbind.token'

/**
 * Storage de sessao da web.
 *
 * `localStorage` (e nao cookie httpOnly) porque o mesmo cliente roda em
 * Tauri e React Native, onde nao existe cookie de dominio — manter o token
 * num header comum e o que permite um so `@orbind/api-client` nas tres
 * plataformas. O trade-off e XSS: nao renderize HTML de terceiros sem sanitizar.
 */
export const webTokenStorage: TokenStorage = {
  get: () => localStorage.getItem(TOKEN_KEY),
  set: (token) => {
    if (token === null) localStorage.removeItem(TOKEN_KEY)
    else localStorage.setItem(TOKEN_KEY, token)
  },
}

const LOCALE_KEY = 'orbind.locale'

export const api = createOrbindClient({
  // Em producao o bundle e servido pela propria API: mesma origem, sem CORS.
  // Em dev o Vite roda em 5173 e a API em 3333.
  baseUrl: import.meta.env.VITE_API_URL ?? (import.meta.env.DEV ? 'http://localhost:3333' : window.location.origin),
  storage: webTokenStorage,
  getLocale: () => localStorage.getItem(LOCALE_KEY) ?? 'pt-BR',
  onUnauthorized: () => {
    // Nao usa o router aqui: o cliente e criado fora da arvore React e nao tem
    // acesso ao navigate. Um reload leva ao guard de rota, que redireciona.
    if (!location.pathname.startsWith('/login')) location.assign('/login')
  },
})

export function setStoredLocale(locale: string) {
  localStorage.setItem(LOCALE_KEY, locale)
}

/** Origem da API (sem o /api): dev aponta para 3333, producao e a origem. */
export const apiOrigin = () =>
  (import.meta.env.VITE_API_URL as string | undefined) ??
  (import.meta.env.DEV ? "http://localhost:3333" : window.location.origin)

/** Base das rotas REST (com o prefixo /api que o servidor usa). */
export const apiBase = () => `${apiOrigin()}/api`

export function getStoredLocale() {
  return localStorage.getItem(LOCALE_KEY) ?? 'pt-BR'
}
